module.exports = __webpack_public_path__ + "static/hero-b5cfe8eac84646e28721ba81f7451a27.png";